import { useEffect } from 'react';
import { Option, isSome } from 'fp-ts/Option';

import { dispatchAlertToaster } from 'adapter/in/common/context/Alert';
import i18n from 'asset/translation';
import { ErrorData } from 'domain/types';

type UseUseCaseAlertsConfig<T> = {
    successMessage?: string;
    errorMessage?: string;
    onSuccess?: (value: T) => void;
    onError?: (error: ErrorData) => void;
};

export const useUseCaseAlerts = <T>(data: Option<T>, error: Option<ErrorData>, config: UseUseCaseAlertsConfig<T>): void => {
    const { successMessage, errorMessage, onSuccess, onError } = config;
    const { setSuccessAlert, setErrorAlert } = dispatchAlertToaster();

    useEffect(() => {
        if (isSome(data)) {
            if (successMessage) {
                setSuccessAlert(i18n.t(successMessage));
            }
            onSuccess?.(data.value);
        }
    }, [data]);

    useEffect(() => {
        if (isSome(error)) {
            setErrorAlert(i18n.t(errorMessage ?? 'common.genericError'));
            onError?.(error.value);
        }
    }, [error]);
};
